export const state = {
  selectedTechApp: [],
}

export const getters = {
  selectedTechApp(state) {
    return state.selectedTechApp
  },
}

export const mutations = {
  SET_SELECTED_TECH_APP(state, payload) {
    state.selectedTechApp = payload
  },
}
